import { NgModule, Optional, SkipSelf } from '@angular/core';
import { SharedModule } from '../shared';
import { InvestigatorSitesStorage } from './investigator-sites-storage';
import { SelectedSiteResolver } from './selected-site-resolver';

@NgModule({
    imports: [
        SharedModule
    ],
    providers: [
        InvestigatorSitesStorage,
        SelectedSiteResolver
    ]
})
export class SitesModule {
    constructor( @Optional() @SkipSelf() sitesModule: SitesModule) {
        if (sitesModule) {
            throw new Error('SitesModule is already loaded');
        }
    }
}